// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__zbk_v","content":"GlobalSearch_content__AYQCP"};